import React, { useCallback, useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import { Button, Container, Row, Col } from 'reactstrap'
import { toast } from 'react-toastify'

import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { StudentService } from 'services/student'
import Loading from 'components/Loading/Loading'
import { StudentsHelper } from 'helpers/students'
import StudentsTable from 'components/Table/StudentsTable'
import PanelContext from 'contexts/Panel'

const ConsultaPage = ({ history, match, location }) => {
  const { year, semester, setYear, setSemester, years } = useContext(PanelContext)
  const { name } = match.params

  const params = new URLSearchParams(location.search)
  const Captcha = params.get('Captcha')

  const [isLoading, setIsLoading] = useState(false)
  const [studentsList, setStudentsList] = useState()

  const goBack = useCallback(() => {
    history.push('/')
  }, [history])

  useEffect(() => {
    const getStudentByName = async (name) => {
      try {
        setIsLoading(true)

        const response = await StudentService.individuallyHome({
          Nome: name,
          Captcha,
          Year: year,
          Semester: semester,
        })

        if (response.status === 200) {
          let data = response.data
          data = StudentsHelper.formatList(data)

          setStudentsList(data)
        }
      } catch (e) {
        toast.error(e?.response?.data || e?.message)
      } finally {
        setIsLoading(false)
      }
    }

    getStudentByName(name)
  }, [Captcha, name, year, semester])

  const handleYearChange = ({ target: { value } }) => {
    const [ year, semester ] = value.split('.')
    setYear(parseInt(year))
    setSemester(parseInt(semester))
  }

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col className="d-flex justify-content-between align-items-center">
              <select
                id="select-year"
                className="form-select"
                aria-label="Selecione o ano"
                onChange={handleYearChange}
                style={{
                  color: '#000',
                  borderColor: '#aaa',
                }}
              >
                {years.map(item => (
                  <option value={item.value} selected={item.value === `${year}.${semester}`}>{item.label}</option>
                ))}
              </select>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="12">
              <p
                className="description"
                style={{
                  fontWeight: 400,
                  color: '#000',
                  letterSpacing: 2,
                  lineHeight: 1.6,
                  marginTop: 30,
                }}
              >
                <span style={{ fontWeight: 600 }}>Resultado da consulta rápida</span> com o nome completo do estudante.
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="text-center" style={{ marginTop: 50, marginBottom: 30 }}>
          <div style={{ marginTop: 30, marginBottom: 30 }}>
            {isLoading ? <Loading /> : <StudentsTable studentsList={studentsList} setStudentsList={setStudentsList} />}
          </div>

          <div className="title-brand" style={{ marginBottom: 25, paddingTop: 10 }}>
            <Col style={{ textAlign: 'center' }}>
              <Button
                onClick={() => (window.location.href = '/#cadastro')}
                className="btn-round"
                color="danger"
                style={{
                  letterSpacing: 1.5,
                  paddingTop: 8,
                  cursor: 'pointer',
                  fontSize: 14,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Quer consultar todos os alunos da sua escola de uma só vez? Clique aqui.
              </Button>
            </Col>
          </div>
        </Container>

        <WhiteFooter />
      </div>
    </>
  )
}

export default withRouter(ConsultaPage)
